import React from "react";
import "./second-banner.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../config";
export default function SecondBanner() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  return (
    <section
      className={`second-banner-section ${
        isVisible ? "section-animation" : ""
      }`}
      ref={ref}
    >
      <div className="container">
        <div className="second-banner-section-wrapper">
          <div className="second-banner-section-heading">
            <h2>
              Experience Intelligent GUI Automation for Seamless Workflows
            </h2>
            <p>
              Unlock efficiency and transform your operations with AI-powered
              automation. Contact us to learn more or request a demo
            </p>
            <div className="second-banner-button-wrapper">
              <a href={config.bookdemo.Link}>
                <button className="second-banner-button">
                  <p>Book Demo</p>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.92969 0.5V2H13.375L0.929688 14.4453L1.98438 15.5L14.4297 3.05469V12.5H15.9297V0.5H3.92969Z"
                      fill="#4275FF"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
